// echarts官网
export const ECHARTS_URL = 'https://echarts.apache.org'
export const ECHARTS_OPTIONS_URL = `${ECHARTS_URL}/zh/option.html`

// 布局
export const LAYOUT_VIEW_ENUM = {
  LRR: 'LRR',
  LCR: 'LCR'
}

export const LAYOUT_VIEW_OPTIONS = [
  { name: '左右右', icon: '', value: LAYOUT_VIEW_ENUM.LRR },
  { name: '左中右', icon: '', value: LAYOUT_VIEW_ENUM.LCR }
]
